module.exports = __webpack_public_path__ + "static/media/s2.6243aba0.png";